import { ReverCard } from '@itsrever/design-system'
import { useTranslation } from 'react-i18next'
import { DailyReturnsChart } from '../daily-returns-chart'

interface MainChartProps {
  returns?: number
  returnsByDay: number[]
  dates: string[]
}

function SimpleLineChart({ returns, returnsByDay, dates }: MainChartProps) {
  const { t, i18n } = useTranslation()

  return (
    <ReverCard className="flex flex-col" fullWidth>
      <div className="flex justify-between px-5 pt-5">
        <div className="flex gap-12">
          {returns !== undefined ? (
            <div>
              <p>{t('main_chart.returns')}</p>
              <div className="mt-2 flex">
                <h3 className="font-bold">
                  {returns.toLocaleString(i18n.language)}
                </h3>
              </div>
            </div>
          ) : null}
        </div>
      </div>
      <div className="flex size-full items-stretch self-stretch">
        <DailyReturnsChart
          className="flex basis-full self-baseline"
          variant="light"
          values={returnsByDay}
          days={dates}
        />
      </div>
    </ReverCard>
  )
}

export default SimpleLineChart
